"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllergyType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var AllergyType_Factory = /** @class */ (function () {
    function AllergyType_Factory() {
    }
    AllergyType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AllergyType1: model.AllergyType1,
            CreatesMedicalAlert: model.CreatesMedicalAlert,
            NotUserEditable: model.NotUserEditable,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    AllergyType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AllergyType1: model.AllergyType1,
            CreatesMedicalAlert: model.CreatesMedicalAlert,
            NotUserEditable: model.NotUserEditable,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return AllergyType_Factory;
}());
exports.AllergyType_Factory = AllergyType_Factory;
